var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ./~/velocity-react/~/lodash/_coreJsData.js
// module id = 3746
// module chunks = 4